import { Injectable } from '@angular/core';
import * as turf from '@turf/turf';

@Injectable({
  providedIn: 'root'
})
export class TurfHelperService {
  constructor() { }
  
  getBufferGeoJSON(lat: number, lng: number, radioKm:number) {
    var point = turf.point([lng, lat]);
    var buffered = turf.buffer(point, (radioKm), {units: 'kilometers'});
    var converted = turf.toWgs84(buffered);
    return buffered;
  }

  getPolygonGeoJSON(polygonPoints: number[][]) {
    polygonPoints.push(polygonPoints[0]);
    var polygon = turf.polygon([polygonPoints]);
    polygon.properties = {Status: "1"};
    var converted = turf.toWgs84(polygon);
    return polygon;
  }

  getCentroidGeoJSON(polygonPoints: number[][]) {
    var polygon = turf.polygon([polygonPoints]);
    var centroid = turf.centroid(polygon);
    var converted = turf.toWgs84(centroid);
    return centroid;
  }

  getFeatureCentroidGeoJSON(feature: turf.Feature) {
    var centroid = turf.centroid(feature);
    return centroid;
  }

  getPointsWithinPolygon(points: any, area: any): turf.FeatureCollection<turf.Point> {
    return turf.pointsWithinPolygon(points, area);
  }

  public getBounds(markers: any){
    var bounds = turf.bbox(markers);
    return bounds;
  }

}
